<template>
  <v-layout column>
    <kernel-press-sheet-info-view
      :loading-error="loadingError"
      :press-sheet="pressSheet"
      :loading="isPSLoading"
    />

    <vbt-tabs
      v-model="tab"
      :loading="isPSLoading"
      :tabs="tabs"
    >
      <template #actions>
        <kernel-press-sheet-actions-list
          :error="loadingError"
          :items="actions"
          @refresh="$_fetchData"
        />
      </template>
      <template #history>
        <kernel-press-sheet-history-list
          :error="loadingError"
          :items="pressSheetHistory"
        />
      </template>
      <template #items>
        <kernel-press-sheet-order-items-list
          :error="loadingError"
          :items="orderItems"
        />
      </template>
    </vbt-tabs>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import { wrapToLoadingFn } from '@helpers';

import KernelPressSheetInfoView from '../_components/KernelPressSheetInfoView.vue';
import KernelPressSheetActionsList from '../_components/KernelPressSheetActionsList.vue';
import KernelPressSheetHistoryList from '../_components/KernelPressSheetHistoryList.vue';
import KernelPressSheetOrderItemsList from '../_components/KernelPressSheetOrderItemsList.vue';

import {
  namespace as PressSheetsNamespace,
  ActionTypes as PressSheetsActionTypes,
} from '../store.types';

const dataLoadingOptions = {
  getterName: 'getPressSheetData',
  parameterize: true,
  searchable: false,
  paged: false,
};

const tabs = Object.freeze([
  { text: 'Order items', key: 'items' },
  { text: 'Actions', key: 'actions' },
  { text: 'History', key: 'history' },
]);

export default {
  name: 'KernelPressSheet',
  components: {
    KernelPressSheetInfoView,
    KernelPressSheetActionsList,
    KernelPressSheetHistoryList,
    KernelPressSheetOrderItemsList,
  },
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  data: () => ({
    tabs,
    tab: 'items',
    isPSLoading: false,
  }),
  computed: {
    ...mapState(PressSheetsNamespace, {
      pressSheet: ({ pressSheet }) => pressSheet,
      actions: ({ pressSheet: { workflowItems: actions } }) => actions || [],
      pressSheetHistory: ({ pressSheetHistory: h }) => h || [],
      orderItems: ({ pressSheet: { orderItems } }) => orderItems || [],
    }),
  },
  methods: {
    ...mapActions(PressSheetsNamespace, {
      getPressSheetData(dispatch) {
        const { id } = this.$route.params;

        this.wrapToLoadingFn({
          req: dispatch.bind({}, PressSheetsActionTypes.GET_PRESS_SHEET, { id }),
          loadingFlagName: 'isPSLoading',
        });
        this.wrapToLoadingFn({
          req: dispatch.bind({}, PressSheetsActionTypes.GET_PRESS_SHEET_HISTORY, { id }),
          noLoadingIndicators: true,
        });
      },
    }),
    wrapToLoadingFn,
  },
};
</script>
